import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlightMealDetailComponent } from './flight-meal-detail.component';
import { AmountFormatPipe, StaticMsgModule } from '@lib/pipes';
import { FormsModule } from '@angular/forms';
import { AmountFormatModule } from '@lib/pipes/amount-format/amount-format.module';

@NgModule({
  declarations: [FlightMealDetailComponent],
  exports: [FlightMealDetailComponent],
  imports: [CommonModule, StaticMsgModule, FormsModule, AmountFormatModule],
  providers: [AmountFormatPipe],
})
export class FlightMealDetailModule {}
